import React from 'react'
import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { SectionItemRoutes } from './Constants/routes';

const SectionItemsAll = () => {
  const match = useRouteMatch();

  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {SectionItemRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/section-items" />
      </Switch>
    </>
  )
}

export default SectionItemsAll;
